import React from 'react';
import './App.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { clearTenantPortalSession, getTenantPortalSession } from './tenantPortalSession';
import { TenantPortalContext } from './TenantPortalContext';

function TenantHeader() {
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const portalCtx = React.useContext(TenantPortalContext);
  const session = getTenantPortalSession();
  const displayFirstName = React.useMemo(() => {
    const raw = (portalCtx?.profile?.full_name || session?.fullName || '').trim();
    const first = raw.split(/\s+/)[0];
    return first || 'Tenant';
  }, [portalCtx?.profile?.full_name, session?.fullName]);

  const goTo = (path) => {
    setOpen(false);
    if (location.pathname !== path) {
      navigate(path);
    }
  };

  return (
    <header className="th-root">
      <div className="th-left">
        <span className="th-app-name">Hi, {displayFirstName}</span>
        <span className="th-app-sub">Tenant portal</span>
      </div>

      <div className="th-right">
        <button
          type="button"
          className={`th-toggle ${open ? 'th-toggle--open' : ''}`}
          aria-label="Open tenant menu"
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          <span />
          <span />
        </button>

        {open && (
          <div className="th-menu" role="menu">
            <button
              type="button"
              className="th-menu-item"
              onClick={() => goTo('/tenant')}
            >
              Dashboard
            </button>
            <button
              type="button"
              className="th-menu-item"
              onClick={() => goTo('/tenant/rent')}
            >
              Rent & payments
            </button>
            <button
              type="button"
              className="th-menu-item"
              onClick={() => goTo('/tenant/maintenance')}
            >
              Submit request
            </button>
            <button
              type="button"
              className="th-menu-item"
              onClick={() => goTo('/tenant/feedback')}
            >
              Feedback form
            </button>
            <button
              type="button"
              className="th-menu-item"
              onClick={() => {
                clearTenantPortalSession();
                goTo('/admin');
              }}
            >
              Logout
            </button>
          </div>
        )}
      </div>
    </header>
  );
}

export default TenantHeader;

